<template>
  <div class="settings">
    <div class="settingbox settingbox--other">
      <div class="setting setting--warmup">
        <button
          class="setting__button setting__button--other"
          :class="{'setting__button--active': currentSetting === 'warmup'}"
          @click="setSetting('warmup')"
        >
          <span class="value big">{{ sec2time(currentTimer['warmup']) }}m</span>
          <span class="label big">Warmup</span>
        </button>
        <span class="line line--warmup"></span>
      </div>
      <div class="setting setting--stretching">
        <button
          class="setting__button setting__button--other setting__button--stretching"
          :class="{'setting__button--active': currentSetting === 'stretching'}"
          @click="setSetting('stretching')"
        >
          <span class="value big">{{ sec2time(currentTimer['stretching']) }}m</span>
          <span class="label big">Stretching</span>
        </button>
        <span class="line line--stretching"></span>
      </div>
    </div>
    <div class="settingbox settingbox--main">
      <div class="setting">
        <button
          class="setting__button"
          :class="{'setting__button--active': currentSetting === 'rounds'}"
          @click="setSetting('rounds')"
        >
          <span class="value">{{ currentTimer['rounds'] }}</span>
          <span class="label">Rounds</span>
        </button>
      </div>
      <div class="setting">
        <button
          class="setting__button"
          :class="{'setting__button--active': currentSetting === 'exercises'}"
          @click="setSetting('exercises')"
        >
          <span class="value">{{ currentTimer['exercises'] }}</span>
          <span class="label">Exercises</span>
        </button>
      </div>
      <div class="setting">
        <button
          class="setting__button"
          :class="{'setting__button--active': currentSetting === 'intervals'}"
          @click="setSetting('intervals')"
        >
          <span class="value">{{ currentTimer['intervals'] }}s</span>
          <span class="label">Interval</span>
        </button>
      </div>
      <div class="setting">
        <button
          class="setting__button"
          :class="{'setting__button--active': currentSetting === 'breaks'}"
          @click="setSetting('breaks')"
        >
          <span class="value">{{ currentTimer['breaks'] }}s</span>
          <span class="label">Low/Break</span>
        </button>
      </div>
    </div>
    <slidercontrol
      v-if="settingsActive"
      :values="currentSetting ? timerSettings[currentSetting].slidervalues : null"
      :current="currentTimer[currentSetting]"
      :currentSetting="currentSetting"
      @changeValue="changeValue"
      :currentMode="currentMode"
    >
    </slidercontrol>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Slidercontrol from '@/components/slidercontrol.vue';

export default {
  name: 'settings',
  components: {
    Slidercontrol,
  },
  props: [],
  data: () => ({
    currentSetting: null,
  }),
  computed: {
    ...mapGetters([
      'settingsActive',
      'timerSettings',
      'currentTimer',
    ]),
    currentMode() {
      if (this.currentSetting === 'warmup' || this.currentSetting === 'stretching') {
        return 'minutes';
      }
      if (this.currentSetting === 'rounds' || this.currentSetting === 'exercises') {
        return false;
      }
      return 's';
    },
  },
  created() {},
  mounted() {},
  methods: {
    toggleActive() {
      this.$store.commit('SETSETTINGSACTIVE', !this.settingsActive);
    },
    setSetting(key) {
      if (key === this.currentSetting) {
        this.$store.commit('SETSETTINGSACTIVE', false);
        this.currentSetting = null;
      } else {
        this.$store.commit('SETSETTINGSACTIVE', true);
        this.currentSetting = key;
      }
    },
    changeValue(timer) {
      this.$store.commit('SETTIMERVALUE', timer);
    },
  },
  watch: {},
};
</script>

<style lang='stylus'>
@import '~styles/variables.styl'
.settings
  width 100%
  // padding .75rem
  transform translate3d(0,10px,0)
  .settings--inactive &
    transform translate3d(0,120px,0)
  transition all .5s ease-out
.label
  display block
  text-transform uppercase
  font-size 12px
.value
  font-size 24px
  font-weight 500
  display block
  margin-bottom .25rem
.line
  width 1px
  border-left 1px dotted weiss
  height 40px
  display block
  transform translate3D(.75rem,0,0)
  transition all .5s ease-out
  &--warmup
    transform translate3D(.75rem,-91px,0)
    .settings--inactive &
      transform translate3D(.75rem,0,0)
  &--stretching
    transform translate3D(70px,-91px,0)
.settingbox
  display flex
  width 90%
  //min-width 300px
  margin 0 auto
  max-width 600px
  // debug(red)
  &--other
    justify-content space-between
    transform translate3D(0,0,0)
  &--main
    align-items stretch
    justify-content space-around
    background rgba(48,66,78,.75)
    border 1px solid weiss
    transform translate3D(0,0,0)
    transition all .5s ease-out
.setting
  &__button
    padding 1rem .5rem
    line-height 1
    width 100%
    font-family 'Fira Sans'
    color weiss
    cursor pointer
    margin 0
    display block
    background transparent
    border none
    &--active
      background rgba(255,255,255,.8)
      color dunkel
    &--other
      padding .375rem .5rem
      text-align left
      border-radius 3px
    &--stretching
      text-align right
      .settings--inactive &
        // padding-top .375rem
  &--warmup
    text-align left
    transition all .5s ease-out
    transform translate3D(0,204px,0)
    .settings--inactive &
      transform translate3D(0,0,0)
  &--stretching
    text-align right
    align-self flex-end
    transition all .5s ease-out
    transform translate3D(0,204px,0)
  .settingbox--main &
    flex 0 0 25%
    justify-content center
</style>
